var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('span',{class:[
      'progress__label',
      _vm.isPlaylistCompleted && 'progress__label--complete' ]},[_vm._v("\n    "+_vm._s(_vm.playlistStatusLabel)+"\n  ")]),_c('span',{staticClass:"progress__percentage"},[_vm._v("\n    "+_vm._s(_vm.percentage ? (_vm.percentage + "% complete") : '')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }